import { useCallback, useEffect, useRef, useState } from 'react'

const useRevealOnce = ({
  enabled = true,
  rootMargin = '0px 0px 12% 0px',
  threshold = 0.05,
} = {}) => {
  const elementRef = useRef(null)
  const [entered, setEntered] = useState(false)

  const ref = useCallback(node => {
    elementRef.current = node
  }, [])

  useEffect(() => {
    if (!enabled || entered) return undefined

    const element = elementRef.current
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches

    if (!element || reducedMotion || !('IntersectionObserver' in window)) return undefined

    const observer = new window.IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return

      setEntered(true)
      observer.disconnect()
    }, { rootMargin, threshold })

    observer.observe(element)

    return () => observer.disconnect()
  }, [enabled, entered, rootMargin, threshold])

  return { entered, ref }
}

export default useRevealOnce
